import {
  Button,
  Flex,
  Form,
  PanelHeader,
  PanelSection,
  PanelTitle,
  Paragraph,
  TextField,
} from '@customerio/pluma-components/react';
import { GoogleSignupPanel } from './google-signup-panel';
import { useEntryStepForm } from './use-entry-step-form';

/** The standard entry form: email plus Google One-Click. */
export function EmailEntryForm() {
  const entry = useEntryStepForm();

  return (
    <>
      <PanelHeader>
        <PanelTitle level="1">Create your account</PanelTitle>
      </PanelHeader>
      <PanelSection>
        <Paragraph variant="secondary" mb="200">
          No credit card required. Try Customer.io for free.
        </Paragraph>
        <GoogleSignupPanel state={entry.googleState} onClick={entry.onGoogleClick} />
      </PanelSection>
      <PanelSection withBorder={false}>
        <Form onSubmit={entry.onSubmit}>
          <TextField
            {...entry.emailField}
            label="Email address"
            placeholder="you@company.com"
            autofocus={true}
            shouldAllowAutofill={true}
            isDisabled={entry.isGoogleBound}
            onInput={entry.onEmailInput}
            onBlur={entry.onEmailBlur}
            isInvalid={entry.isEmailInvalid}
            error={entry.visibleEmailError}
          />

          <Flex justifyContent="flex-end" mt="200">
            <Button
              type="submit"
              variant="primary"
              icon="chevron-right"
              iconPosition="trailing"
              isDisabled={entry.isSubmitDisabled}
              isLoading={entry.isSubmitting}
            >
              {entry.submitLabel}
            </Button>
          </Flex>
        </Form>
      </PanelSection>
    </>
  );
}
